















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

interface CountryItem {
  text: string;
  value: string;
}

@Component({})
export default class AutocompleteCountry extends Vue {
  @Prop({ default: '' }) readonly value!: string;
  @Prop({ default: () => [] }) readonly items!: CountryItem[];
  @Prop({ default: 'Sélectionnez un pays' }) readonly noDataLabel!: string;
  @Prop({ default: '' }) readonly name!: string;
  @Prop({ default: '' }) readonly label!: string;
  @Prop({ default: () => [] }) readonly errors!: string[];
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly error!: boolean;

  public pValue: string = '';
  public visible: boolean = false;
  public activeItem: number | null = null;
  private maxInitialItems: number = 6;

  created() {
    this.pValue = this.value;
  }

  @Watch('value')
  onValue(newVal: string) {
    this.pValue = newVal;
  }

  @Watch('pValue')
  onPValue(newVal: string) {
    this.$emit('update:value', newVal);
  }

  get filteredCountries(): CountryItem[] {
    const normalize = (str: string): string =>
      str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    
    let result: CountryItem[] = [];
    
    if (this.pValue) {
      // Filtrer selon la saisie avec une normalisation avancée
      result = this.items.filter(item => 
        normalize(item.text).includes(normalize(this.pValue))
      );
    } else {
      // Si le champ est vide, privilégier les pays populaires
      const popularCountries = this.items.filter(item => 
        ["France", "Belgique", "Suisse", "Luxembourg", "Canada", "Allemagne"].includes(item.text)
      );
      
      result = popularCountries.length > 0 
        ? popularCountries 
        : this.items;
    }
    
    // Toujours limiter le nombre de résultats à maxInitialItems
    return result.slice(0, this.maxInitialItems);
  }

  get isValidCountry(): boolean {
  // Check if the field is empty
  const isEmpty = !this.pValue || this.pValue.trim() === '';
  
  // Check for exact match in the items list
  const isValid = this.items.some(c => 
    c.text.trim() === this.pValue.trim()
  );
  
  // Emit validation result, considering empty field as invalid
  if (this.pValue) {
    this.$emit('country-validation', !isEmpty && isValid);
  }
  
  // Return false if empty or not in the list
  return !isEmpty && isValid;
}
  
    onInput() {
      this.visible = true;
      this.activeItem = null;
    }
  
    onKeydown(event: KeyboardEvent) {
      switch (event.code) {
        case 'ArrowDown':
          event.preventDefault();
          if (this.activeItem === null || this.activeItem >= this.filteredCountries.length - 1) {
            this.activeItem = 0;
          } else {
            this.activeItem++;
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (this.activeItem === null || this.activeItem <= 0) {
            this.activeItem = this.filteredCountries.length - 1;
          } else {
            this.activeItem--;
          }
          break;
        case 'Enter':
          if (this.activeItem !== null) {
            const item = this.filteredCountries[this.activeItem];
            this.onClick(item);
          }
          break;
      }
    }
  
    onClick(item: CountryItem) {
      this.visible = false;
      this.activeItem = null;
      this.pValue = item.text;
      this.$emit('update:value', item.text);
      this.$emit('input', item.text); 
    }
  
    onMouseover(index: number) {
      this.activeItem = index;
    }
  
    onBlur() {
      setTimeout(() => {
        this.visible = false;
      }, 100);
    }
  }
  